import { render } from "./pending_invoices.vue?vue&type=template&id=5781ecf8&scoped=true"
import script from "./pending_invoices.vue?vue&type=script&lang=js"
export * from "./pending_invoices.vue?vue&type=script&lang=js"

import "./pending_invoices.vue?vue&type=style&index=0&id=5781ecf8&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5781ecf8"]])

export default __exports__